import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import React from "react";

import { SecretRecord } from "@/shared/domain/secrets";
import {
  useSecretValue,
  getQueryKey,
} from "@/shared/domain/secrets/hooks/useSecretValue";
import { useUpdateSecretMutation } from "@/shared/domain/secrets/hooks/useUpdateSecretMutation";

import { HiddenTextReveal } from "../../shared/components/HiddenTextReveal";

export interface SecretValueProps {
  secretRecord: SecretRecord;
  autoLoadSecret?: boolean;
}

export const SecretValue: React.FC<SecretValueProps> = ({
  secretRecord,
  autoLoadSecret = false,
}) => {
  const secretValueQuery = useSecretValue(secretRecord, autoLoadSecret);
  const updateSecretMutation = useUpdateSecretMutation();
  const queryClient = useQueryClient();

  const handleSnackbarClose = () => {
    void queryClient.resetQueries({
      queryKey: getQueryKey(secretRecord.name),
    });
  };

  return (
    <>
      <HiddenTextReveal
        initialValue={secretValueQuery.data || ""}
        isLoading={updateSecretMutation.isPending || secretValueQuery.isLoading}
        onSaveEdit={(secretValue: string) => {
          updateSecretMutation.mutate({
            secretName: secretRecord.name,
            newValue: secretValue,
            orgId: secretRecord.org_id,
          });
        }}
        onShowSecret={() => {
          void secretValueQuery.refetch();
        }}
      />
      <Snackbar
        open={secretValueQuery.isError}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        action={
          <IconButton onClick={handleSnackbarClose}>
            <CloseIcon />
          </IconButton>
        }
        message="Failed to fetch secret. Please try again."
      />
    </>
  );
};
